import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Paper } from "@mui/material";
import useSave from "../../Hooks/useSave";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ProductGroups() {
  const [products, setProducts] = useState([]);
  const [open, setOpen] = React.useState(false);

  // const location = useLocation()
  // const [currentPage, setCurrentPage] = useState(location.state?.currentPage);
  // const [searchText, setSearchText] = useState(location.state?.searchText);
  const navigate = useNavigate();
  const { fetchGraphql, DialogSave } = useSave();

  const addonOptions = {
    record: {
      groupId: `new${products.length + 1}`,
      groupCode: "",
      groupName: "",
      groupUnitOfMeasure: "",
    },
    edit: () => {},
    save: (tableMeta) => {
      const copyState = [...products];

      const productGroup = copyState.find(
        (item) => item["groupId"] === tableMeta.rowData[0],
      );

      const newProductGroup = { ...productGroup };

      delete newProductGroup.groupId;

      if (productGroup.groupId.includes("new")) {
        // console.log("new");
        return fetchGraphql({
          query: `mutation CreateProductGroup($productGroup: groupInput) {
            createProductGroup(productGroup: $productGroup)
          }`,
          variables: { productGroup: newProductGroup },
        }).then((result) => {
          productGroup.groupId = result.data.createProductGroup;

          setProducts(copyState);

          return Promise.resolve("done");
        });
      } else {
        // console.log("old");

        return fetchGraphql({
          query: `mutation UpdateProductGroup($productId: ID, $productGroup: groupInput) {
            updateProductGroup(productId: $productId, productGroup: $productGroup)
          }`,
          variables: {
            productGroup: newProductGroup,
            productId: productGroup.groupId,
          },
        }).then((result) => {
          return Promise.resolve("done");
        });
      }
    },
    delete: (tableMeta) => {
      fetchGraphql({
        query: `mutation DeleteProduct($productId: ID) {
          deleteProduct(productId: $productId)
        }`,
        variables: { productId: tableMeta.rowData[0] },
      });
    },
  };

  const [textField, selectField, newRecord, actions, options] =
    useDatatableAddon(products, setProducts, "groupId", addonOptions);

  useEffect(() => {
    fetchGraphql({
      query: `query ProductGroups {
        productGroups {
          groupId
          groupCode
          groupName
          groupUnitOfMeasure
        }
      }`,
    }).then((result) => setProducts(result.data.productGroups));
  }, []);

  const columns = [
    {
      name: "groupId",
      options: {
        display: false,
      },
    },
    {
      name: "groupCode",
      label: "Group Code",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            firstRow: true,
            check: (e, id) => {
              // console.log(e, id);
              if (
                products
                  .filter((item) => item.groupId !== id)
                  .map((item) => item.groupCode)
                  .includes(e.target.value)
              ) {
                setOpen(true);
              }
            },
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "groupName",
      label: "Group Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return textField(tableMeta, value, "options", updateValue);
        },
      },
    },
    {
      name: "groupUnitOfMeasure",
      label: "Unit Of Measure",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            tabNext: true,
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    { ...actions },
  ];

  try {
    return (
      <>
        <DialogSave />
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"There Is another item with this code."}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please change it.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                e.preventDefault();
                setOpen(false);
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Paper
          sx={{
            width: "100%",
            height: "auto",
            marginLeft: "20px",
            padding: "20px",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            variant="contained"
            sx={{ margin: "0px 0px 20px auto" }}
            onClick={() =>
              newRecord({
                groupId: `new${products.length + 1}`,
                groupCode: "",
                groupName: "",
                groupUnitOfMeasure: "",
              })
            }
          >
            <AddIcon />
            New Group
          </Button>

          <MUIDataTable
            sx={{ height: "100px" }}
            title={"Products"}
            data={products}
            columns={columns}
            options={options}
          />
        </Paper>
      </>
    );
  } catch (error) {
    console.log(error);
  }
}
